// extracted by mini-css-extract-plugin
module.exports = {"container":"ingredientCard_container__FQpiT","image":"ingredientCard_image__1LLiQ","headline":"ingredientCard_headline__YZEjO","description":"ingredientCard_description__UOsGP"};